import React from 'react';
import { PropTypes } from 'prop-types';
import './Success.scss';
import CreditSuccess from '../creditsuccess/CreditSuccess';
import NewPlanDetails from '../NewPlanDetails/NewPlanDetails';
import SuccessTile from './SuccessTile';
import offerImage from '../../assets/headphones.png';
import phoneBroadband from '../../assets/phone_broadband.svg';
import SubscriptionDiscountSuccessTile from './SubscriptionDiscountSuccessTile';
import Configuration from '../../common/Configuration.json';


const SuccessHeader = (props) => {
  const addOfferElement = (offers, element) => {
    if (offers.length > 0) {
      offers.push(<div className="row offer offer-plus">+</div>);
    }
    offers.push(element);
    return offers;
  };

  const renderOffers = () => {
    let offers = [];
    if (props.hasSubscriptionDiscount) {
      offers = addOfferElement(offers, <SubscriptionDiscountSuccessTile />);
    }

    if (props.withMobileDiscount) {
      offers = addOfferElement(offers, <SuccessTile
        image={phoneBroadband}
        title={`You've got a $${Math.abs(Configuration.skinnyMobileCustomerDiscount.amount)} monthly discount`}
        message={'For being a Skinny mobile customer'}
      />);
    }

    if (props.offer.enabled) {
      offers = addOfferElement(offers, <SuccessTile
        image={offerImage}
        title="A nice freebie for you"
        message={
          'To say thanks for joining Skinny broadband we\'re giving you free'
          + ` ${props.offer.name} (worth $${props.offer.value}).`
        }
      />);
    }
    return offers.map(offer => offer);
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 success-header-chosen">
          You&apos;ve chosen
        </div>
      </div>
      <NewPlanDetails
        address={props.address}
        plan={props.plan}
        isByoModemSelected={props.isByoModemSelected}
      />
      {props.credit &&
        <CreditSuccess credit={props.credit} />
      }
      {renderOffers()}
    </div>
  );
};

SuccessHeader.defaultProps = {
  credit: 0,
  address: '',
  plan: {},
  offer: {}
};

SuccessHeader.propTypes = {
  credit: PropTypes.number,
  address: PropTypes.string,
  plan: PropTypes.object,
  offer: PropTypes.object,
  hasSubscriptionDiscount: PropTypes.bool,
  withMobileDiscount: PropTypes.bool,
  isByoModemSelected: PropTypes.bool,
};

export default SuccessHeader;



/** WEBPACK FOOTER **
 ** ./src/components/Success/SuccessHeader.js
 **/